<template>
  <div>
    <h1 class="main-title">login</h1>
    <form @submit.prevent="loginUser">
      <input
        required
        v-model.lazy="email"
        class="login-input"
        type="email"
        placeholder="Email..."
      >
      <br>
      <input
        required
        v-model.lazy="password"
        class="login-input"
        type="password"
        placeholder="Password..."
      >
      <button
        class="btn-grad login-btn"
        type="submit"
      >Login</button>
      <p
        v-if="loginFail"
        class="login-failure"
      >Invalid Email or Password</p>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapState(["loginFail"]),
  },
  methods: {
    loginUser() {
      const formData = {
        email: this.email.trim(),
        password: this.password.trim(),
      };

      this.$store.dispatch("login", formData);

      this.password = "";
    },
  },
};
</script>

<style>
.login-input {
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.301);
}

.login-btn {
  margin-top: 25px !important;
}

.login-failure {
  background-color: tomato;
  border-radius: 10px;
  margin: 30px 10px 10px 10px;
  padding: 10px 30px;
  display: inline-block;
  font-weight: 500;
  color: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.212);
}
</style>